import { ServerData, API_Request_Body, API_Response, Config } from './types';

const serverData = (window as any).__REV_GEN_DATA__ as ServerData;
const API_Namespace = `${serverData.siteUrl}/wp-json/revenue-generator/v1`;

const endpoints = {
	auth: `${API_Namespace}/auth`,
	contributions: `${API_Namespace}/contributions`,
	app: `${API_Namespace}/app`,
};

export const availableLayouts = ['button', 'box', 'bar', 'footer'];

const getRequestHeaders = () => {
	return {
		'X-WP-Nonce': serverData.nonce,
	};
};

export const pushContributionToApi = (contributionId: number, data: API_Request_Body) => {
	let endpoint = endpoints.contributions;
	let method = 'POST';

	if (contributionId !== 0) {
		endpoint = `${endpoint}/${contributionId}`;
		method = 'PUT';
	}

	const headers = getRequestHeaders();
	const body = JSON.stringify(data);

	return fetch(endpoint, { headers, method, body }).then(response => {
		if (response.ok) {
			return response.json();
		} else {
			throw new Error('Error saving the contribution.');
		}
	});
};

export const getContributionFromApi = (contributionId: number) => {
	return fetch(`${endpoints.contributions}/${contributionId}`, { headers: getRequestHeaders() }).then(response => {
		if (response.ok) {
			return response.json();
		} else {
			throw new Error(`Error fetching contribution #${contributionId}.`);
		}
	});
};

export const getAllContributionsFromApi = () => {
	return fetch(`${endpoints.contributions}`, { headers: getRequestHeaders() }).then(response => {
		if (response.ok) {
			return response.json();
		} else {
			throw new Error('Error fetching contributions from the API.');
		}
	});
};

export const deleteContributionFromApi = (contributionId: number) => {
	return fetch(`${endpoints.contributions}/${contributionId}`, {
		headers: getRequestHeaders(),
		method: 'DELETE',
	}).then(response => {
		if (response.ok) {
			return response.json();
		} else {
			throw new Error('Error talking to API while deleting the contribution offer. Please try again.');
		}
	});
};

export const validateCredentials = (clientID: string, clientSecret: string) => {
	const headers = getRequestHeaders();
	const body = JSON.stringify({
		client_id: clientID,
		client_secret: clientSecret,
	});

	return fetch(endpoints.auth, { headers, body, method: 'POST' }).then(response => response.status);
};

export const getConfig = () => {
	return fetch(endpoints.app, {
		headers: getRequestHeaders(),
		method: 'GET',
	}).then(response => {
		if (response.ok) {
			return response.json();
		} else {
			throw new Error('Error connecting to site API. Please try again.');
		}
	});
};

export const updateConfig = (data: Config) => {
	const headers = getRequestHeaders();
	const body = JSON.stringify(data);

	return fetch(endpoints.app, { headers, body, method: 'POST' }).then(response => response.status);
};

export const copyToClipboard = (text: string) => {
	const el = document.createElement('textarea');
	el.value = text;
	el.setAttribute('readonly', '');
	el.style.position = 'absolute';
	el.style.left = '-9999px';
	document.body.appendChild(el);
	el.select();
	document.execCommand('copy');
	document.body.removeChild(el);
};

export const copyShortcodeToClipboard = (id: number) => {
	copyToClipboard(`[laterpay_contribution id="${id}"]`);
};

export const getElementForPortal = () => {
	return document.getElementById('rev-gen-modal-portal') as Element;
};

export const getAmountFromCents = (amount: number): string => {
	const value = amount / 100;

	return value.toFixed(2);
};

export const appPaths = {
	welcome: '/onboarding/welcome',
	dashboard: '/contributions/dashboard',
	builder: '/contributions/builder',
};

export const defaultContributionData: API_Response = {
	ID: -1,
	post_title: '',
	all_amounts: [5, 10, 25],
	dialog_header: 'Support the Author',
	dialog_content: '',
	button_label: '',
	layout_type: 'box',
	created_updated_info: '',
};
